const requiredEnvVars = ['REACT_APP_STRIPE_PUBLIC_KEY', 'REACT_APP_EXCHANGE_RATE_API'];

requiredEnvVars.forEach((varName) => {
    if (!process.env[varName]) {
        console.error(`ERROR: Environment variable ${varName} is not defined.`);
    }
});

const EXCHANGE_RATE_API= process.env.REACT_APP_EXCHANGE_RATE_API || 'https://api.exchangerate-api.com/v4/latest';
const STRIPE_CALLBACK_URL = process.env.REACT_APP_STRIPE_CALLBACK_URL || 'https://www.stagem2o.com/connect-stripe';

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.startsWith('127.')
)

const API_LOCAL_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const API_URL = isLocalhost ? API_LOCAL_URL : window.location.origin;

const getIsWhiteLabel = () => {
    const whiteLabelDomains = process.env.REACT_APP_WHITE_LABEL_DOMAINS?.split(',') || [];
    return whiteLabelDomains.some(domain => window.location.hostname.includes(domain));
};
const IS_WHITE_LABEL = getIsWhiteLabel();

export const ENV = {
    API_URL,
    IS_WHITE_LABEL,
    EXCHANGE_RATE_API,
    STRIPE_CALLBACK_URL,
    CURRENT_DOMAIN: window.location.origin,
    CURRENT_HOST: window.location.host,
    CURRENT_HOST_NAME:window.location.hostname,
    IS_LOCALHOST: isLocalhost,
    MAIN_DOMAIN_URL: process.env.REACT_APP_MAIN_DOMAIN_URL,
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    APP_CHATS: process.env.REACT_APP_CHATS,
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    GOOGLE_REDIRECT_URI: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
    APPLE_CLIENT_ID: process.env.REACT_APP_APPLE_CLIENT_ID,
    APPLE_REDIRECT_URI: process.env.REACT_APP_APPLE_REDIRECT_URI,
}